<template>
    <form-row title="Total Earnest Money Due" :no_border="true" class="my-6">
        <div class="sm:w-2/5">
            <div v-show="total_due_by_percent">
                <input-money
                    :value="total_due_by_percent"
                    :read_only="true"
                    tabindex="-1"
                />
            </div>

            <div v-show="! total_due_by_percent">
                <input-money
                    v-model="total_due_entered"
                    :read_only="read_only"
                />
            </div>

            <input
                name="total_earnest_money"
                type="hidden"
                :value="total_due"
                :read_only="true"
            />
        </div>

        <div class="sm:w-3/5 flex items-center mt-4 sm:mt-0">
            <span class="flex-shrink-0 text-sm text-gray-warm-800 sm:pl-6 pr-6">
                {{ $t('- OR -') }}
            </span>

            <div class="w-24">
                <input-percent
                    name="total_earnest_percent"
                    v-model="total_earnest_percent"
                    :read_only="read_only"
                />
            </div>

            <span class="text-sm text-gray-warm-800 leading-snug pl-4">
                {{ $t('of purchase price') }}
            </span>
        </div>
    </form-row>
</template>

<script>
import MoneyFunctions from '../../../mixins/money-functions.js';

export default {
    mixins: [
        MoneyFunctions,
    ],

    props: {
        deal: { default: () => ({}) },
        purchase_price: {},
        value: {},
        read_only: { default: false },
    },

    data() {
        return {
            total_earnest_percent: this.deal.total_earnest_percent,
            total_due_entered: this.deal.total_earnest_money,
        }
    },

    computed: {
        total_due_by_percent() {
            return this.total_earnest_percent
                ? this.formatMoney((this.total_earnest_percent / 100) * this.moneyVal(this.purchase_price))
                : null;
        },
        total_due() {
            return this.total_due_by_percent || this.total_due_entered;
        },
    },

    watch: {
        total_due(val) {
            this.$emit('input', val);
        },
    },
}
</script>
